import CustomButton from "components/CustomButton/CustomButton";
import SpaceDialogAction from "./SpaceDialogAction";

const DialogSaveInformationConfirmation = ({
	dialogConfirm, saveInformation
}) => {
	return (
		<SpaceDialogAction
			dialog={dialogConfirm}
			title="¿Deseas guardar los cambios?"
			content="Recuerda que al guardar los cambios, podrás visualizarlos al ingresar nuevamente al listado de alumnos.">
			<CustomButton
				variant="secondary"
				width="120px"
				text="No, cancelar"
				onClick={dialogConfirm.hide} />
			<CustomButton
				width="120px"
				text="Si, guardar"
				onClick={saveInformation} />
		</SpaceDialogAction>
	);
}

export default DialogSaveInformationConfirmation;